module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "blurb-and-subscription-container w-100 py-5"
  }, [_c('div', {
    staticClass: "blurb-and-subscription"
  }, [_c('div', {
    staticClass: "display-flex align-center justify-space-between gap-8"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "subscription-container"
  }, [_c('div', {
    staticClass: "subscription-plan bg-white"
  }, [_c('div', {
    staticClass: "d-flex justify-center align-center tab-group"
  }, _vm._l((_vm.tabList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "tab-text width-50 cursor-pointer text-center",
      class: {
        'active-tab': item.id == _vm.tab
      },
      on: {
        "click": function($event) {
          _vm.setTab(item.id)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])
  })), _vm._v(" "), (_vm.categoryPlan == 'creator') ? _c('div', {
    staticClass: "font-space-grotesk"
  }, [_c('div', {
    staticClass: "text-31 font-weight-700 mb-1"
  }, [_vm._v("\n                " + _vm._s(_vm.creators.title) + "\n                "), _c('span', {
    staticClass: "price-text"
  }, [_vm._v(_vm._s(_vm.tab === "yearly" ? "$10/mo" : "$12/mo"))])]), _vm._v(" "), _c('div', {
    staticClass: "text-grey-purple-1 text-16 font-weight-500 mb-4"
  }, [_vm._v("\n                " + _vm._s(_vm.creators.subtitle) + "\n              ")]), _vm._v(" "), _vm._l((_vm.creators.option), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "d-flex align-center justify-start gap-10 pb-2"
    }, [_vm._m(1, true), _vm._v(" "), _c('span', {
      staticClass: "font-poppins text-14 font-weight-500"
    }, [_vm._v("\n                  " + _vm._s(item) + "\n                ")])])
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "package-card-btn font-weight-700 mt-3",
    attrs: {
      "block": "",
      "text": ""
    },
    on: {
      "click": _vm.handleGetStarted
    }
  }, [_vm._v("\n                Get Started\n              ")])], 2) : _c('div', {
    staticClass: "font-space-grotesk"
  }, [_c('div', {
    staticClass: "text-31 font-weight-700 mb-1"
  }, [_vm._v("\n                " + _vm._s(_vm.premium.title) + "\n                "), _c('span', {
    staticClass: "price-text"
  }, [_vm._v(_vm._s(_vm.tab === "yearly" ? "$100/mo" : "$12/mo"))])]), _vm._v(" "), _c('div', {
    staticClass: "text-grey-purple-1 text-16 font-weight-500 mb-4"
  }, [_vm._v("\n                " + _vm._s(_vm.premium.subtitle) + "\n              ")]), _vm._v(" "), _vm._l((_vm.premium.option), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "d-flex align-center justify-start gap-10 pb-2"
    }, [_vm._m(2, true), _vm._v(" "), _c('span', {
      staticClass: "font-poppins text-14 font-weight-500"
    }, [_vm._v("\n                  " + _vm._s(item) + "\n                ")])])
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "package-card-btn font-weight-700 mt-3",
    attrs: {
      "block": "",
      "text": ""
    },
    on: {
      "click": _vm.handleGetStarted
    }
  }, [_vm._v("\n                Coming soon\n              ")])], 2)])])])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "bg-grey-white upgrade-plan-dialog",
      "fullscreen": ""
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.closeDialog($event)
      }
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-center align-center full-height"
  }, [_c('div', {
    staticClass: "display-flex justify-center align-start gap-14 subscription-div",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "upgrade-plan-dialog"
  }, [_c('div', {
    staticClass: "display-flex justify-center align-center logo-container"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": require('@/assets/ys_logo_primary-black.svg'),
      "aspect-ratio": "1",
      "height": "24",
      "width": "124"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subscription-plan upgrade-plan-dialog__content"
  }, [_c('div', {
    staticClass: "d-flex justify-center align-center tab-group"
  }, _vm._l((_vm.tabList), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "tab-text width-50 cursor-pointer text-center",
      class: {
        'active-tab': item.id == _vm.tab
      },
      on: {
        "click": function($event) {
          _vm.setTab(item.id)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "credit-card bg-white mb-4"
  }, [_c('div', {
    staticClass: "font-inter text-20 font-weight-700"
  }, [_vm._v("PREMIUM")]), _vm._v(" "), _c('div', {
    staticClass: "font-inter text-16 font-weight-500"
  }, [_vm._v("\n                All access for everyone.\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center font-space-grotesk"
  }, [_c('span', {
    staticClass: "text-36 font-weight-700"
  }, [_vm._v("\n                  $" + _vm._s(_vm.tab === "yearly" ? 100 : 12) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "text-14 font-weight-500 text-grey-3 mt-2"
  }, [_vm._v("\n                  /year\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "credit-card"
  }, [_c('div', {
    staticClass: "text-dmsans-14 mb-3"
  }, [(_vm.tab === 'yearly') ? [_vm._v("\n                  Your card will be charged $100 each year starting today.\n                ")] : [_vm._v("\n                  Your card will be charged $12 each month starting today.\n                ")]], 2), _vm._v(" "), _c('hr', {
    staticClass: "divider mb-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center justify-space-between mb-3"
  }, [_c('div', {
    staticClass: "text-dmsans-14 font-weight-700 mb-2"
  }, [_vm._v("\n                  Credit card\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-8"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/mobile/icon/visa.svg"),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/mobile/icon/master-card.svg"),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/mobile/icon/american-express.svg"),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../assets/mobile/icon/discover.svg"),
      "width": "24",
      "height": "16"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "credit-card__input bg-white"
  }, [_c('div', {
    staticClass: "display-flex align-center px-3 credit-card__number"
  }, [_c('div', {
    staticClass: "StripeElement",
    attrs: {
      "id": "card-element"
    }
  })])]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-poppins text-18 font-weight-600 white--text w-100 bg-blue-1 btn-pay",
    on: {
      "click": _vm.purchase
    }
  }, [_vm._v("\n                Purchase\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "font-dm-sans text-center"
  }, [_c('span', {
    staticClass: "text-16"
  }, [_vm._v(" Powered by ")]), _vm._v(" "), _c('span', {
    staticClass: "text-20 font-weight-700"
  }, [_vm._v("stripe")])])], 1)])]), _vm._v(" "), _c('v-icon', {
    staticClass: "material-icons icon icon-close cursor-pointer icon--x-large",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("\n          close\n        ")])], 1)])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "bg-grey-white upgrade-plan-dialog",
      "fullscreen": ""
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.closeSuccessDialog($event)
      }
    },
    model: {
      value: (_vm.successDialog),
      callback: function($$v) {
        _vm.successDialog = $$v
      },
      expression: "successDialog"
    }
  }, [_c('v-icon', {
    staticClass: "material-icons icon icon-close cursor-pointer icon--x-large",
    on: {
      "click": _vm.closeSuccessDialog
    }
  }, [_vm._v("\n      close\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "bg-grey-white h-100 w-100 display-flex justify-center align-center"
  }, [_c('div', {
    staticClass: "success-dialog-content"
  }, [_c('div', {
    staticClass: "bg-white success__content mt-5 font-poppins display-flex flex-column align-center justify-center"
  }, [_c('img', {
    staticClass: "mb-5 text-center w-100 logo-img",
    attrs: {
      "src": require('@/assets/ys_logo_primary-black.svg'),
      "aspect-ratio": "1",
      "height": "24",
      "width": "124"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "user-img",
    attrs: {
      "src": "/static/images/user.png",
      "aspect-ratio": "1",
      "height": "150",
      "width": "150"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "thank-you-text text-24 font-weight-700"
  }, [_vm._v("Thank you,")]), _vm._v(" "), _c('div', {
    staticClass: "thank-you-text text-24 font-weight-700 display-flex align-center"
  }, [(_vm.currentUser) ? _c('span', [_vm._v(_vm._s(_vm.currentUser.first_name))]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "check-icon",
    attrs: {
      "src": "/static/images/ic_circle_check.svg",
      "aspect-ratio": "1",
      "height": "15",
      "width": "15"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "my-3 text-16 font-weight-500"
  }, [_vm._v("\n            Your subscription is active!\n          ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-dashboard white--text font-weight-700 text-14 mt-3",
    on: {
      "click": _vm.goToDashboard
    }
  }, [_vm._v("\n            Go to dashboard\n          ")])], 1)])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blurb-container"
  }, [_c('div', {
    staticClass: "white--text font-space-grotesk font-weight-500 text-50"
  }, [_vm._v("\n            Go Ad-Free\n            "), _c('br'), _vm._v("\n            Empower Artists\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "max-w-18px d-flex justify-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/check-icon-black.svg"),
      "aspect-ratio": "1",
      "height": "18",
      "width": "18"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "max-w-18px d-flex justify-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/check-icon-black.svg"),
      "aspect-ratio": "1",
      "height": "18",
      "width": "18"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3829967c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/landing-new/components/UpgradePlan.vue
// module id = 1685
// module chunks = 180